<template>
  <IziGrid class="top-challenge-container">
    <IziCol class="title">
      <IziIcon>favorite</IziIcon>
      <span>Most played challenge</span>
    </IziCol>
    <IziCol class="content">
      <IziGrid>
        <IziCol col="6">Game1</IziCol>
        <IziCol col="6">23213</IziCol>
      </IziGrid>
    </IziCol>
  </IziGrid>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { Game } from "../../model/Game.model";
import Base from "../base/Base.vue";
@Options({})
export default class TopChallenge extends Base {
  lstgame: Game[] = [
    {
      id: 1,
      name: "2",
      description: "",
      genre: "",
      imageUrl: "",
      length: "",
      tag: "",
    },
  ];
}
</script>

<style lang="scss">
.top-challenge-container {
  .content {
    font-size: 10px;
  }
  .title {
    .material-icons {
      font-size: unset;
    }
    display: flex;
    .custom-icon {
      pointer-events: none;
    }
  }
}
</style>
